module.exports = __webpack_public_path__ + "static/media/np.9f2d8bc5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/np.svg
// module id = 734
// module chunks = 0